import styled from 'styled-components';

const BasicSettingsStyled = styled.div`
  .basic-title {
    font-size: 19px;
    font-family: SourceHanSansCN;
    font-weight: 500;
    color: #000000;
    margin-bottom: ${(props) => props.theme.spacing(4)};
  }
  .single-select {
    width: 80px;
    text-align: center;
  }
  .date-month {
    margin-top: 2px;
    margin-right: 2px;
    /* position: relative; */
  }
  .basic-name {
    min-width: 381px;
  }
  .date-wrap {
    margin-top: ${(props) => props.theme.spacing(14 / 8)};
  }
  .label-require {
    color: #ff0000;
    font-size: 14px;
  }
  .label-name {
    font-size: 14px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    color: #000000;
  }
  .basic-cycle {
    padding-top: ${(props) => props.theme.spacing(5)};
    color: #000000;
  }
  .basic-cycle-group {
    font-size: 16px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    color: #000000;
    line-height: 50px;
    /* align-items:center; */
    .date {
      padding: 0 ${(props) => props.theme.spacing(9 / 8)} 0
        ${(props) => props.theme.spacing(1)};
    }
    .basic-cycle-group-wrap {
      display: flex;
      flex-direction: rwo;
      align-items: end;
    }
  }
  .cycle-select-wrap {
    display: flex;
    flex-direction: row;
    font-size: 16px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    color: #000000;
  }
  .birth-wrap {
    padding-bottom: ${(props) => props.theme.spacing(98 / 8)};
  }
  .basic-cycle-label {
    font-size: 16px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    color: #000000;
  }
  .errorTips {
    border-bottom: 1px solid red;
  }
  .error-wrap {
    color: red;
  }
  .checkbox-radio-disabled-color .Mui-disabled {
    color: darkgray;
  }
`;

export default BasicSettingsStyled;
